import './footer.css'





export default function Footer() {


    return (

        <div className="footer-wrapper" style={{}}>
            <p className="footer-p">©2026 honeybeewebsolutions.com | All rights reserved</p>
        </div>
    )
}